import React from 'react'
import { format } from 'date-fns'
// Local
import {
  CONDITION,
  FORMAT
} from '../../../constant'
import { EncounterConditionDisplay } from '../../authenticated/types'


type Props = {
  condition: EncounterConditionDisplay
}

function ConditionAddressedDate(
  props: Props
): JSX.Element | null {
  const { condition } = props
  if (
    condition.conditionCode === CONDITION.CODE.ADDRESSED &&
    condition.addressedDate
  ) {
    return (
      <div className="m-1-top">
        <span className="italic">
          <span>Condition last addressed on</span>
          <span>&nbsp;</span>
          <span>{ format(condition.addressedDate, FORMAT.DATE) }</span>
        </span>
      </div>
    )
  }
  return null
}

export default ConditionAddressedDate
